import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import * as Styled from "./welcome-screen.style";
import { TabHeader, TabSubHeader, } from "ui/components/panels/home-menu/tabs/tab-header";
import { ReleaseNotes } from "ui/components/elements/release-notes";
import { selectors, useAppSelector } from "store";
export var Welcome = function () {
    var t = useTranslation().t;
    var translationKey = function (suffix) {
        return "home-menu.welcome-screen.".concat(suffix);
    };
    var releaseNotes = useAppSelector(selectors.selectReleaseNotes);
    useEffect(function () {
        if (!releaseNotes) {
            return;
        }
        localStorage.setItem("lastViewedNewsflashId", releaseNotes[0].id);
    }, [releaseNotes]);
    return (_jsxs(Styled.WelcomeScreen, { children: [_jsx(TabHeader, { header: t(translationKey("header")) }), _jsx(TabSubHeader, { header: t(translationKey("sub-header")) }), _jsxs(Styled.WelcomeScreenText, { children: [_jsx("p", { children: t(translationKey("tool-description")) }), _jsx("p", { children: t(translationKey("author")) })] }), _jsx(Styled.Disclaimer, { children: t(translationKey("disclaimer")) }), releaseNotes ? (_jsxs(Styled.CustomReleaseNotesContainer, { children: [_jsx(TabHeader, { header: t("newsflash.title") }), _jsx(ReleaseNotes, { releaseNotes: releaseNotes })] })) : null] }));
};
